import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import { NavLink} from "react-router-dom";
import "@aws-amplify/ui-react/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import { Flex, Divider, Text, Heading, View, Button} from '@aws-amplify/ui-react';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { multiRowSelection } from '../agGridRowSelection';
//import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import { themeQuartz } from 'ag-grid-community'; //import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import Loadingmini from '../components/loadingmini';

export default function Reservationactionhistory({resId}) {
  const [is_loading, updateIsLoading] = React.useState(false);
  const [count, setCount] = useState(0);
  const [res, updateRes] = useState({status:"Contact support if this message stays for more than 30 seconds",rows:[]})
  const columns = [
        {
            headerName: 'Modified',
            field: 'modified',
            filter: true
        },
        {
            headerName: 'Action',
            field: 'action',
            filter: true,
            width: 150
        },
        {
            headerName: 'Reason',
            field: 'reason',
            filter: true,
            width: 220
        },
        {
            headerName: 'Status',
            field: 'status',
            filter: true,
            width: 150
        },
        {
            headerName: 'Start',
            field: 'start_string',
            filter: true
        },
        {
            headerName: 'End',
            field: 'end_string',
            filter: true
        },
        {
            headerName: 'Driver',
            field: 'driver_name',
            filter: true
        },
        {
            field: 'VIN',
            filter: true
        },
        {
            headerName: 'Vehicle ID',
            field: 'id',
            filter: true
        },
        {
            headerName: 'Vehicle Plates',
            field: 'license',
            filter: true
        },
        {
            headerName: 'Version',
            field: 'version',
            filter: true
        }
  ];
  

  async function fetchPageData() {
    updateIsLoading(true)
    if(resId)
    {
        let session = await Auth.currentSession()      
        let accessToken = session.getAccessToken()
        let jwt = accessToken.getJwtToken()
        let user = await Auth.currentAuthenticatedUser(); 
        const myInit = {queryStringParameters:{ 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt": jwt,
            "api_endpoint":"api3:portal:reservation_actions",
            "request_type":"GET",
            "res_id":resId
        }};
        try {
            const res = await API.get('adminWebTools','/ago',myInit)
            updateRes(res)
            updateIsLoading(false)
        }
        catch (e) {
            console.log('reservationactionhistory error: '+toString(e));
            updateIsLoading(false)
        }
    }
  }

  useEffect(() => {
    fetchPageData()
    },[count])



  return (
      <Flex
        direction="column"
      >
        <View style={{padding:"1rem"}}>
            <Divider />
            {
                is_loading ? <Loadingmini /> : 
                <Flex 
                    direction='column'
                >
                    <Heading level={2}>Reservation Action History</Heading>
                    <Text style={{width:'100%'}}>This is the history of actions taken on this reservation</Text>
                    <View>
                        <Button onClick={() => setCount(count + 1)}>
                            PRESS TO GET LATEST UPDATES
                        </Button>
                    </View>
                    <Divider />
                    <Text><i>Hint: To search, long-click on mobile or click top-right on pc.</i></Text>
                    <View style={{width:"100%"}}>
                        <View 
                            theme={themeQuartz} //className="ag-theme-quartz" // applying the grid theme
                            style={{ height: 500 }} // the grid will fill the size of the parent container
                        >
                                <AgGridReact
                                    rowData={res.rows}
                                    columnDefs={columns}
                                    rowSelection={multiRowSelection}
                                    paginationPageSize={500}
                                    paginationPageSizeSelector={[10, 25, 50]}
                                    enableCellTextSelection={true}
                                />
                        </View>
                    </View>
                    <Divider />
                </Flex>
            }
        </View>
      </Flex>
  );
}
